/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  TjkENX: 'Search error',
  'automation-menu.empty-state.image.alt': 'Empty automation list icon',
  'automation-menu.empty-state.learn-more.link': 'Learn more about the manual trigger',
  'automation-menu.modal.empty.automations.admin.description':
    'Use the manual trigger to populate a menu of selections that anyone, or people you specify, can apply as one-click automations.',
  'automation-menu.modal.empty.automations.user.description':
    'Admins haven’t configured any manually triggered automations yet.',
  'automation-menu.modal.error.description': 'This is taking awhile to load. Try refreshing the page.',
  'automation-menu.modal.error.image.alt': 'Error icon',
  'automation-menu.modal.footer.automate-button': 'Automate',
  'automation-menu.modal.footer.cancel-button': 'Cancel',
  'automation-menu.modal.footer.get-started-button': 'Create automation',
  'automation-menu.modal.footer.ok-button': 'Ok',
  'automation-menu.modal.header.icon.label': 'Automation modal header icon',
  'automation-menu.success-state.message': 'Your automation is in progress',
  'compass.applied_components_count.non-final':
    'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component} other {{numberOfComponents, number} components}}',
  'fabric.linking.access_exists_description': 'Request access to view this content from {hostname}.',
  'fabric.linking.actions': 'Actions',
  'fabric.linking.add_account': 'Add account',
  'fabric.linking.ai_summarize': 'Summarise',
  'fabric.linking.ai_summarized': 'Summarised by Atlassian Intelligence',
  'fabric.linking.ai_summarized_abbreviation': 'Summarised by AI',
  'fabric.linking.ai_summarized_info': 'Information quality may vary. <a>Learn more</a>',
  'fabric.linking.ai_summarized_info_short': 'Content quality may vary',
  'fabric.linking.ai_summarizing': 'Atlassian Intelligence is working...',
  'fabric.linking.ai_summary_action': 'Summarise with AI',
  'fabric.linking.ai_summary_action_description': 'Summarise the content of this link using Atlassian Intelligence.',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarise.",
  'fabric.linking.ai_summary_error_generic':
    'Atlassian Intelligence (AI) isn’t responding. Try again later or <a>check the status of AI</a>.',
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
  'fabric.linking.assigned_to': 'Assigned to {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
  'fabric.linking.automation-action.confluence.page.modal.title': 'Page automations',
  'fabric.linking.automation-action.icon.label': 'Automation icon',
  'fabric.linking.automation-action.title': 'View automation rules',
  'fabric.linking.automation-action.tooltip': 'Select an automation rule to run',
  'fabric.linking.beta': 'Beta',
  'fabric.linking.cancel': 'Cancel',
  'fabric.linking.cannot_connect': "Can't connect, try again",
  'fabric.linking.cannot_find_link': "Can't find link",
  'fabric.linking.check_this_link': 'Check this link',
  'fabric.linking.click_to_join': 'Join {context}',
  'fabric.linking.click_to_join_description': "You've been approved, so you can join {context} right away.",
  'fabric.linking.close': 'Close',
  'fabric.linking.connect_account_description': "We'll open a new page to help you connect your {name} account",
  'fabric.linking.connect_link_account': 'Connect to preview',
  'fabric.linking.connect_link_account_card_view': 'Connect',
  'fabric.linking.connect_link_account_card_view_description':
    'To show a preview of this link, connect your {context} account.',
  'fabric.linking.connect_link_account_card_view_name': 'Connect your {context} account',
  'fabric.linking.connect_to': 'Connect to {name}',
  'fabric.linking.connect_unauthorised_account_action': 'Connect to {context}',
  'fabric.linking.connect_unauthorised_account_description':
    'Connect your {context} account to collaborate on work across Atlassian products.',
  'fabric.linking.connect_unauthorised_account_description-appify':
    'Connect your {context} account to collaborate on work across Atlassian apps.',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    'Connect your account to collaborate on work across Atlassian products.',
  'fabric.linking.connect_unauthorised_account_description_no_provider-appify':
    'Connect your account to collaborate on work across Atlassian apps.',
  'fabric.linking.continue': 'Continue',
  'fabric.linking.copied_summary_action_description': 'Copied summary to clipboard',
  'fabric.linking.copied_url_to_clipboard': 'Copied!',
  'fabric.linking.copy_summary_action': 'Copy summary',
  'fabric.linking.copy_summary_action_description': 'Copy summary',
  'fabric.linking.copy_url_to_clipboard': 'Copy link',
  'fabric.linking.couldnt_load_link': "We couldn't load this link for an unknown reason.",
  'fabric.linking.create_on_absolute': 'Created on {context}',
  'fabric.linking.create_on_relative': 'Created {context}',
  'fabric.linking.created_by': 'Created by {context}',
  'fabric.linking.delete': 'Delete',
  'fabric.linking.direct_access': 'Join now',
  'fabric.linking.direct_access_description':
    'Your team uses {product} to collaborate and you can start using it right away!',
  'fabric.linking.direct_access_title': 'Join {product} to view this content',
  'fabric.linking.download': 'Download',
  'fabric.linking.download_description': 'Download this file into your local storage',
  'fabric.linking.download_file': 'Download file',
  'fabric.linking.edit': 'Edit',
  'fabric.linking.follow': 'Follow',
  'fabric.linking.follow_goal': 'Follow goal',
  'fabric.linking.follow_goal_description': 'Follow this goal to get notifications on updates',
  'fabric.linking.follow_goal_error':
    'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
  'fabric.linking.follow_project': 'Follow project',
  'fabric.linking.follow_project_description': 'Follow to get notifications on this project',
  'fabric.linking.follow_project_description-galaxia': 'Follow to get notifications on this space',
  'fabric.linking.follow_project_error':
    'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
  'fabric.linking.follow_project_error-galaxia':
    'We encountered an error while trying to follow the space. Check your connection or refresh the page and try again.',
  'fabric.linking.forbidden_access': 'Your access is forbidden',
  'fabric.linking.forbidden_description': 'Contact your admin to request access to {hostname}.',
  'fabric.linking.forbidden_title': "You don't have access to this content",
  'fabric.linking.generic_error_message': 'An error occurred',
  'fabric.linking.go_back': 'Go back',
  'fabric.linking.invalid_permissions': 'Restricted content',
  'fabric.linking.invalid_permissions_description':
    "You'll need to request access or try a different account to view this preview.",
  'fabric.linking.join_to_view': 'Join {context} to view this issue',
  'fabric.linking.join_to_view-issue-term-refresh': 'Join {context} to view this work item',
  'fabric.linking.learn_more_about_connecting_account':
    'Learn more about connecting your account to Atlassian products.',
  'fabric.linking.learn_more_about_connecting_account-appify':
    'Learn more about connecting your account to Atlassian apps.',
  'fabric.linking.learn_more_about_connecting_account_experiment_short':
    'Turn your URLs into rich, interactive previews.',
  'fabric.linking.learn_more_about_smart_links': 'Learn more about Smart Links.',
  'fabric.linking.link_safety_warning_message':
    'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
  'fabric.linking.loading': 'Loading...',
  'fabric.linking.modified_on_absolute': 'Updated on {context}',
  'fabric.linking.modified_on_relative': 'Updated {context}',
  'fabric.linking.more_actions': 'More actions',
  'fabric.linking.no_access_title': 'Join {product} to view this content',
  'fabric.linking.not_found_description': "The page doesn't exist or it may have changed after this link was added.",
  'fabric.linking.not_found_title': "We can't show you this {product} page",
  'fabric.linking.open_issue_in_jira': 'Open issue in Jira',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Open work item in Jira',
  'fabric.linking.open_link_in_a_new_tab': 'Open link in a new tab',
  'fabric.linking.owned_by': 'Owned by {context}',
  'fabric.linking.owned_by_override': 'By {context}',
  'fabric.linking.pending_request': 'Your access request is pending',
  'fabric.linking.preview_close': 'Close preview',
  'fabric.linking.preview_description': 'Open a full screen preview of this link',
  'fabric.linking.preview_improved': 'Open preview',
  'fabric.linking.preview_max_size': 'View full screen',
  'fabric.linking.preview_min_size': 'Close full screen',
  'fabric.linking.preview_modal': 'Open preview modal',
  'fabric.linking.preview_panel': 'Open preview panel',
  'fabric.linking.priority_blocker': 'Blocker',
  'fabric.linking.priority_critical': 'Critical',
  'fabric.linking.priority_high': 'High',
  'fabric.linking.priority_highest': 'Highest',
  'fabric.linking.priority_low': 'Low',
  'fabric.linking.priority_lowest': 'Lowest',
  'fabric.linking.priority_major': 'Major',
  'fabric.linking.priority_medium': 'Medium',
  'fabric.linking.priority_minor': 'Minor',
  'fabric.linking.priority_trivial': 'Trivial',
  'fabric.linking.priority_undefined': 'Undefined',
  'fabric.linking.read_time': '{context} min read',
  'fabric.linking.related': 'Related',
  'fabric.linking.related_links_found_in': 'Found in',
  'fabric.linking.related_links_includes_links_to': 'Includes links to',
  'fabric.linking.related_links_modal_error_description': 'Check your connection or refresh the page to try again',
  'fabric.linking.related_links_modal_error_title': "We're having trouble loading related links",
  'fabric.linking.related_links_modal_title': 'Related links',
  'fabric.linking.related_links_modal_unavailable_description':
    'We continuously review and add related links for updated pages or other content types',
  'fabric.linking.related_links_modal_unavailable_title': "We couldn't find any related links",
  'fabric.linking.related_links_not_found': "We didn't find any links to show here.",
  'fabric.linking.related_links_view_related_links': 'View related links',
  'fabric.linking.related_links_view_related_urls': 'View recent links',
  'fabric.linking.request_access': 'Request access',
  'fabric.linking.request_access_description':
    'Your team uses {product} to collaborate. Send your admin a request for access.',
  'fabric.linking.request_access_pending': 'Pending approval',
  'fabric.linking.request_access_pending_description': 'Your request to access {hostname} is awaiting admin approval.',
  'fabric.linking.request_access_pending_title': 'Access to {product} is pending',
  'fabric.linking.request_access_to_view': 'Request access to {context} to view this issue',
  'fabric.linking.request_access_to_view-issue-term-refresh': 'Request access to {context} to view this work item',
  'fabric.linking.request_denied': 'Your access request was denied',
  'fabric.linking.request_denied_description':
    "Your admin didn't approve your request to view {product} pages from {hostname}.",
  'fabric.linking.restricted_link': 'Restricted link, try another account',
  'fabric.linking.retry': 'Retry',
  'fabric.linking.save': 'Save',
  'fabric.linking.sent_on_absolute': 'Sent on {context}',
  'fabric.linking.sent_on_relative': 'Sent {context}',
  'fabric.linking.srclink': 'View in',
  'fabric.linking.srclinkunknown': 'View Original',
  'fabric.linking.status_change_load_error': 'We couldn’t load the statuses and transitions',
  'fabric.linking.status_change_permission_error': 'You don’t have permission to transition this issue.',
  'fabric.linking.status_change_permission_error-issue-term-refresh':
    'You don’t have permission to transition this work item.',
  'fabric.linking.status_change_update_error': 'We couldn’t update the status',
  'fabric.linking.team_members_count': '{context} members',
  'fabric.linking.try_again': 'Try again',
  'fabric.linking.try_another_account': 'Try another account',
  'fabric.linking.unassigned': 'Unassigned',
  'fabric.linking.unauthorised_account_description':
    "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
  'fabric.linking.unauthorised_account_description_no_provider':
    "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
  'fabric.linking.unauthorised_account_name': "We can't display private pages from {context}",
  'fabric.linking.unauthorised_account_name_no_provider': "We can't display private pages",
  'fabric.linking.unfollow': 'Unfollow',
  'fabric.linking.unfollow_goal': 'Unfollow goal',
  'fabric.linking.unfollow_goal_description': 'Unfollow to stop receiving notifications for this goal',
  'fabric.linking.unfollow_goal_error':
    'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
  'fabric.linking.unfollow_project': 'Unfollow project',
  'fabric.linking.unfollow_project_description': 'Unfollow to stop receiving project notifications',
  'fabric.linking.unfollow_project_description-galaxia': 'Unfollow to stop receiving space notifications',
  'fabric.linking.unfollow_project_error':
    'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
  'fabric.linking.unfollow_project_error-galaxia':
    'We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again.',
  'fabric.linking.unlink_account': 'Unlink Account',
  'fabric.linking.updated_by': 'Modified by {context}',
  'fabric.linking.user_attributes': '{context}',
  'fabric.linking.view': 'View',
};
